module.exports = __webpack_public_path__ + "static/media/supportMessagesSent_75_100.76a5868b.png";